module.exports = __webpack_public_path__ + "img/d1.9816b92a.png";